import { paperStyles } from './LogHistoryDrawer.styles';

export const DEFAULT_DATE_RANGE_DAYS = 30;

export const RECALCULATED_CARD_TITLE = 'Recalculated, with no saved change behind them';

export const SAVE_RECALCULATED_CARD_TITLE = 'Recalculated by saving pending changes';

export const paperProps = {
  sx: paperStyles,
};

export const slideProps = {
  timeout: { enter: 300, exit: 300 },
  appear: true,
};
